import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
export default function Status() {

    const location = useLocation();
    const navigate = useNavigate();
    const query = new URLSearchParams(location.search);
    const confirmStatus = query.get("status");

    const FinalnavigationPath = "/StudentsDigisign";
    console.log("FinalnavigationPath", FinalnavigationPath, confirmStatus);

    useEffect(() => {
        handleVacancyResponse();
    }, []);

    const handleVacancyResponse = () => {
        if (confirmStatus === "S") {
            navigate(FinalnavigationPath, {
                replace: true,
                state: {
                    eSignStatus: "S",
                    eSignMessage: "E-signed Successfully!",
                },
            });
        } else if (confirmStatus === "F") {
            navigate(FinalnavigationPath, {
                replace: true,
                state: {
                    eSignStatus: "F",
                    eSignMessage: "E-sign Failed! Please try again.",
                },
            });
        } else {
            navigate(FinalnavigationPath, {
                replace: true,
                state: {
                    eSignStatus: "I",
                    eSignMessage: "Invalid response from e-sign service.",
                },
            });
        }
    };

    return <React.Fragment />;
}
